/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  mutation MyMutation($contentSummaryId: ID!) {
    ContentMoveToTop(contentSummaryId: $contentSummaryId) {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
